var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-content" },
    [
      _c("h5", { staticClass: "mb-3" }, [_vm._v("Dados Básicos")]),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Tipo de Credenciamento",
                    "label-class": "required"
                  }
                },
                [
                  _c("b-form-radio-group", {
                    class: _vm.getRadioGroupClass(),
                    attrs: {
                      options: _vm.credentialingTypeOptions,
                      state: _vm.getFieldState("credentialing_type"),
                      disabled: _vm.disabled,
                      stacked: ""
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("credentialing_type", $event)
                      }
                    },
                    model: {
                      value: _vm.formData.credentialing_type,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "credentialing_type", $$v)
                      },
                      expression: "formData.credentialing_type"
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Selecione o tipo de credenciamento ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: { label: "Área de Atuação", "label-class": "required" }
                },
                [
                  _c("b-form-radio-group", {
                    class: _vm.getRadioGroupClass(),
                    attrs: {
                      options: _vm.activityAreaOptions,
                      state: _vm.getFieldState("activity_area"),
                      disabled: _vm.disabled,
                      stacked: ""
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("activity_area", $event)
                      }
                    },
                    model: {
                      value: _vm.formData.activity_area,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "activity_area", $$v)
                      },
                      expression: "formData.activity_area"
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Selecione uma área de atuação ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Nome da Entidade",
                    "label-class": "required",
                    "label-for": "entityName"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "required",
                    attrs: {
                      id: "entityName",
                      value: _vm.formData.entity_name,
                      placeholder: "Digite o nome da entidade",
                      state: _vm.getFieldState("entity_name"),
                      disabled: _vm.disabled,
                      readonly: ""
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("entity_name", $event)
                      }
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Nome da entidade é obrigatório ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "CNPJ",
                    "label-class": "required",
                    "label-for": "cnpj"
                  }
                },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "##.###.###/####-##",
                        expression: "'##.###.###/####-##'"
                      }
                    ],
                    staticClass: "required",
                    attrs: {
                      id: "cnpj",
                      value: _vm.formData.cnpj,
                      placeholder: "00.000.000/0000-00",
                      state: _vm.getFieldState("cnpj"),
                      disabled: _vm.disabled,
                      readonly: ""
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("cnpj", $event)
                      }
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" CNPJ válido é obrigatório ")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "CNAE Principal",
                    "label-class": "required",
                    "label-for": "mainCnae"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "required",
                    attrs: {
                      id: "mainCnae",
                      value: _vm.formData.main_cnae,
                      placeholder: "Digite o código CNAE principal da entidade",
                      state: _vm.getFieldState("main_cnae"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("main_cnae", $event)
                      }
                    }
                  }),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-info mr-1" }),
                    _vm._v(
                      " Código da Classificação Nacional de Atividades Econômicas "
                    )
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" CNAE Principal é obrigatório ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Telefone",
                    "label-class": "required",
                    "label-for": "phone"
                  }
                },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "(##) #####-####",
                        expression: "'(##) #####-####'"
                      }
                    ],
                    staticClass: "required",
                    attrs: {
                      id: "phone",
                      value: _vm.formData.phone,
                      placeholder: "(00) 00000-0000",
                      state: _vm.getFieldState("phone"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("phone", $event)
                      }
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Telefone é obrigatório ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Endereço Completo",
                    "label-class": "required",
                    "label-for": "address"
                  }
                },
                [
                  _c("b-form-textarea", {
                    staticClass: "required",
                    attrs: {
                      id: "address",
                      value: _vm.formData.address,
                      placeholder: "Digite o endereço completo da entidade",
                      rows: "3",
                      state: _vm.getFieldState("address"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("address", $event)
                      }
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Endereço completo é obrigatório ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "E-mail",
                    "label-class": "required",
                    "label-for": "email"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "bg-light required",
                    attrs: {
                      id: "email",
                      value: _vm.formData.email,
                      type: "email",
                      placeholder: "email@entidade.com",
                      state: _vm.getFieldState("email"),
                      disabled: true,
                      readonly: ""
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("email", $event)
                      }
                    }
                  }),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _c("i", { staticClass: "feather icon-lock mr-1" }),
                    _vm._v(
                      " Este e-mail não pode ser alterado pois é usado para identificação (juntamente com o código de segurança) e recuperação dos dados do credenciamento. "
                    )
                  ]),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" E-mail válido é obrigatório ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("h6", { staticClass: "mt-4 mb-3 text-muted" }, [
        _vm._v("Representante Legal")
      ]),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "8" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Nome do Representante Legal",
                    "label-class": "required",
                    "label-for": "legalRepresentativeName"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "required",
                    attrs: {
                      id: "legalRepresentativeName",
                      value: _vm.formData.legal_representative_name,
                      placeholder:
                        "Digite o nome completo do representante legal",
                      state: _vm.getFieldState("legal_representative_name"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "legal_representative_name",
                          $event
                        )
                      }
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Nome do representante legal é obrigatório ")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "CPF do Representante Legal",
                    "label-class": "required",
                    "label-for": "legalRepresentativeCpf"
                  }
                },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "###.###.###-##",
                        expression: "'###.###.###-##'"
                      }
                    ],
                    staticClass: "required",
                    attrs: {
                      id: "legalRepresentativeCpf",
                      value: _vm.formData.legal_representative_cpf,
                      placeholder: "000.000.000-00",
                      state: _vm.getFieldState("legal_representative_cpf"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "legal_representative_cpf",
                          $event
                        )
                      }
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" CPF válido é obrigatório ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Cargo do Representante Legal",
                    "label-class": "required",
                    "label-for": "legalRepresentativePosition"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "required",
                    attrs: {
                      id: "legalRepresentativePosition",
                      value: _vm.formData.legal_representative_position,
                      placeholder: "Digite o cargo do representante legal",
                      state: _vm.getFieldState("legal_representative_position"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "legal_representative_position",
                          $event
                        )
                      }
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Cargo do representante legal é obrigatório ")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "E-mail do Representante Legal",
                    "label-class": "required",
                    "label-for": "legalRepresentativeEmail"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "required",
                    attrs: {
                      id: "legalRepresentativeEmail",
                      value: _vm.formData.legal_representative_email,
                      type: "email",
                      placeholder: "email@representante.com",
                      state: _vm.getFieldState("legal_representative_email"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "legal_representative_email",
                          $event
                        )
                      }
                    }
                  }),
                  _c("b-form-invalid-feedback", [
                    _vm._v(
                      " E-mail válido do representante legal é obrigatório "
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }